import ActionManager from '../ActionManager'

import GetDSPParameters from './GetDSPParameters'
ActionManager.register(GetDSPParameters, ['stores:MainStore'])

import ListAvailableDSP from './ListAvailableDSP'
ActionManager.register(ListAvailableDSP, ['stores:MainStore'])